/*
 * Classes-Start Controller Start.
 */
var ClassesStartController = (function ($) {

    var bread, classstart, breadholder; //, masthead; 

    classstart = $("section[aria-label='Classes Start']");
    bread = $("ul.breadcrumbs");
    breadholder = $("div.js-breadcrumbs-holder");
    //masthead = $("div.masthead");
    
    function ready() {
        moveclassesStart();
    }

    function moveclassesStart() {
        if (!BreakpointController.isMobile() && classstart.length) {
            $(breadholder).addClass("breadcrumb-classes-start");
            $(classstart).insertAfter(bread);
            if (bread.height() > 21) {
                $("body.inner #main").addClass("classesStartFixBread");
            }
        } //else if (classstart.length && $(classstart).parents('.js-breadcrumbs-holder').length) {
            //$(classstart).insertAfter(masthead);
        //} 
    }
    
    $(ready);
    return;

})(jQuery);

/*
 * Classes-Start Controller End.
 */